import SelectField from "../../SelectField";
import { useFormContext } from "react-hook-form";
import DatePicker from "../../DatePicker";
import InputTextArea from "../../InputTextArea";
import { RootState } from "../../../store/root-reducer";
import { connect } from "react-redux";
import { GoTrash } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import * as Api from "../../../service/api";

function DamageBox({
  idx,
  item,
  claimItemId,
  onDelete,
  warrItems,
  occuredReasonOptions,
  actionTakenOptions,
  damageTypesOptions,
}) {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const warrItem = warrItems.find(({ id }) => +id === +claimItemId);
      if (warrItem?.modelNumber) {
        const data = await Api.aceClaimOptions.specificLocations(
          warrItem?.modelNumber
        );
        const mappedData = data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setLocationOptions(mappedData);
      }
    })();
    return () => {};
  }, [claimItemId, item.id, warrItems]);

  return (
    <div className="space-y-3">
      <div className="bg-[#F7F7F7] text-black font-semibold justify-between  min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
        {t("Damage")} {idx + 1}
        {idx > 0 && (
          <button
            type="button"
            className=" hover:bg-red-100 p-1"
            onClick={() => onDelete(idx, item)}
          >
            <GoTrash color="#DB3C32" size={18} />
          </button>
        )}
      </div>
      <SelectField
        label={"Damage Type"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].damage_type`}
        defaultValue={item.damageType?.id}
        options={damageTypesOptions}
        required
        placeholder="Select Damage Category"
      />
      <SelectField
        label={"Damage Area"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].damage_area`}
        defaultValue={item.specificLocation?.id}
        options={locationOptions}
        required
        placeholder="Select Damage Area"
      />
      <DatePicker
        label={"When did you notice the damage"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].when_did_you_notice_the_damage`}
        required
        placeholder="Select damage notice date"
      />
      <SelectField
        label={"How did it happen"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].how_did_it_happen`}
        defaultValue={item.howDidOccur?.id}
        options={occuredReasonOptions}
        required
        placeholder="Select How did it happen"
      />
      <SelectField
        label={"Did you take any steps to remedy ?"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].did_you_take_any_steps_to_remedy`}
        defaultValue={
          item.actionTaken?.id || item.did_you_take_any_steps_to_remedy
        }
        options={actionTakenOptions}
        required
        placeholder="Did you take any steps to remedy"
      />
      <InputTextArea
        label={"Note"}
        control={control}
        name={`claimItemDamage.[${claimItemId}].[${idx}].note`}
        required
        placeholder="Describe more about damage"
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claimId: state?.aceClaim.claimId || "",
  warrItems: state?.aceClaim?.warranty_items || [],
});

export default connect(mapStateToProps)(DamageBox);
